// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kFw0","newExpiryDate":"styles_newExpiryDate__1ln07","footer":"styles_footer__1iBsq"};